<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <section class="pt-5 px-6">
    <div>
      <h2 class="text-xl font-medium text-gray-900">
        {{ t('Codio Impact Modules') }}
      </h2>
      <p>{{ t('Please select a module on the left.') }}</p>
    </div>
  </section>
</template>
